import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pr-1"
}
const _hoisted_2 = {
  key: 1,
  class: "mb-2"
}
const _hoisted_3 = {
  key: 0,
  class: "text-medium-emphasis"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_property_value = _resolveComponent("ontos-property-value")!
  const _component_ontos_hidden_count = _resolveComponent("ontos-hidden-count")!
  const _component_ontos_field_failures = _resolveComponent("ontos-field-failures")!
  const _component_ontos_view_info = _resolveComponent("ontos-view-info")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, {
    justify: "start",
    align: "start"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleProperties, (property) => {
        return (_openBlock(), _createBlock(_component_v_col, {
          key: property.alias,
          cols: "auto"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ontos_view_info, {
              title: property.name
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.valuesOf(property), (value, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                    (index > 0)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_ctx.inline(property) && _ctx.needsValueSeparator(property))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_1, " | "))
                            : (!_ctx.inline(property))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_2))
                              : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true),
                    _createVNode(_component_ontos_property_value, {
                      property: property,
                      value: value,
                      item: _ctx.instance,
                      context: _ctx.context,
                      "choice-domains": _ctx.choiceDomains,
                      variant: "detail",
                      onPreview: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('preview', $event))),
                      onLink: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('link', $event)))
                    }, null, 8, ["property", "value", "item", "context", "choice-domains"])
                  ], 64))
                }), 128)),
                _createVNode(_component_ontos_hidden_count, {
                  count: _ctx.hiddenCount(_ctx.instance, property)
                }, null, 8, ["count"]),
                (!_ctx.valuesOf(property).length && !_ctx.hiddenCount(_ctx.instance, property))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, "—"))
                  : _createCommentVNode("", true),
                _createVNode(_component_ontos_field_failures, {
                  failures: _ctx.failuresAt(_ctx.instance, property.alias)
                }, null, 8, ["failures"])
              ]),
              _: 2
            }, 1032, ["title"])
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }))
}